import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingNav from '../../../components/LandingNav';
import { BLOG_POSTS } from '../../../config/blog-posts';
import '../../../styles/blog.css';

const tikTokLinks = [
  {
    id: 'video-1',
    label: 'Video 1 — Green Screen Video - Comedic Template',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7600463737044159774',
    stats: ['43.3k views'],
  },
  {
    id: 'video-2',
    label: 'Video 2 — EGC: When a customer requests a specific barista to make their coffe',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7599733525054491934',
    stats: ['16.8k views'],
  },
  {
    id: 'video-3',
    label: 'Video 3 — EGC: POV your barista’s order - product promo',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7598599307511532830',
    stats: ['27.2k views'],
  },
  {
    id: 'video-4',
    label: 'Video 4 — Graphic carousel - in store, product promo',
    url: 'https://www.tiktok.com/@officialphilzcoffee/photo/7597855165122661662',
    stats: ['15.9k views'],
  },
  {
    id: 'video-5',
    label: 'Video 5 — EGC: Let’s make our pistachio spice cold brew - product promo',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7597100382325640461',
    stats: ['6.8k views'],
  },
  {
    id: 'video-6',
    label: 'Video 6 — Image Carousel, 2016 trend',
    url: 'https://www.tiktok.com/@officialphilzcoffee/photo/7595714138723159326',
    stats: ['9.9k views'],
  },
  {
    id: 'video-7',
    label: 'Video 7 — EGC: In another universe, we’re just two nutty cold brews - trend',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7595267726365494559',
    stats: ['3.4k views'],
  },
  {
    id: 'video-8',
    label: 'Video 8 — EGC: Responding to a comment/stitching a video making the specialty drink',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7594135216764030238',
    stats: ['14.7k views'],
  },
  {
    id: 'video-9',
    label: 'Video 9 — EGC: Let’s make winter drinks - product promo',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7593141468622097719',
    stats: ['4.8k views'],
  },
  {
    id: 'video-10',
    label: 'Video 10 — Canva template product carousel',
    url: 'https://www.tiktok.com/@officialphilzcoffee/photo/7592286922853125407',
    stats: ['22.7k views'],
  },
  {
    id: 'video-11',
    label: 'Video 11 — EGC: Making a new new menu item in store',
    url: 'https://www.tiktok.com/@officialphilzcoffee/video/7590809448877149470',
    stats: ['68.7k views'],
  },
];

export default function PhilzCoffeeBlogPage() {
  const navigate = useNavigate();
  const post = BLOG_POSTS.find((p) => p.slug === 'philz-coffee');

  // Should never happen (we ship meta for the post), but keep safe.
  if (!post) {
    return (
      <div className="landing-page">
        <LandingNav />
        <main className="blog-container">
          <div className="blog-header">
            <h1 className="blog-title">Blog post not found</h1>
            <p className="blog-subtitle">This post isn’t available yet.</p>
            <div className="blog-header-actions">
              <button className="blog-btn secondary" onClick={() => navigate('/blog')}>
                Back to Blog
              </button>
              <button className="blog-btn primary" onClick={() => navigate('/contact')}>
                Contact
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <LandingNav />
      <main className="blog-container">
        <header className="blog-post-hero">
          <button className="blog-backlink" onClick={() => navigate('/blog')}>
            ← Back to Blog
          </button>

          <div className="blog-post-meta">
            {post.logoSrc && (
              <div className="blog-post-logo">
                <img src={post.logoSrc} alt={post.logoAlt || post.brand || 'Brand'} />
              </div>
            )}
            <div>
              <div className="blog-post-kicker">
                {post.brand ? `${post.brand} case study` : 'Blog'} {post.dateLabel ? `• ${post.dateLabel}` : ''}
              </div>
              <h1 className="blog-post-title">{post.title}</h1>
              <p className="blog-post-excerpt">{post.excerpt}</p>
            </div>
          </div>
        </header>

        <article className="blog-post-body">
          <section className="blog-post-section blog-toc">
            <div className="blog-toc-title">Table of Contents</div>
            <ol>
              <li>
                <a href="#data-audit">Data Audit: Deconstructing the "Philz Formula"</a>
              </li>
              <li>
                <a href="#barista-expert">The Barista as Expert: Solving Decision Fatigue via "Trust Transfer"</a>
              </li>
              <li>
                <a href="#alive-store">The "Alive Store" Effect: Providing Customer Service at Scale</a>
              </li>
              <li>
                <a href="#production-paradox">The Production Paradox: Why Lo-Fi is the New High-End in 2026”</a>
              </li>
              <li>
                <a href="#operational-sop">Operational SOP: How to Build the Philz Content Pipeline</a>
              </li>
              <li>
                <a href="#final-verdict">Final Verdict: Why Authenticity Scales and Polish Stagnates</a>
              </li>
              <li>
                <a href="#scaling-framework">Scaling the Framework: Building Your Human Moat with CrewCast</a>
              </li>
              <li>
                <a href="#content-under-analysis">List of content under analysis</a>
              </li>
            </ol>
          </section>

          <section className="blog-post-section blog-callout">
            <p style={{ marginTop: 0 }}>
              <strong>Premise:</strong> In the coffee sector, "The Vibe" is the primary currency. But in 2026, a vibe curated by a corporate marketing team feels like a stage set - pretty, but hollow.
            </p>
            <p style={{ marginBottom: 0 }}>
              Our latest data dive into <strong>Philz Coffee (January 2026)</strong> reveals a fascinating shift in digital strategy. While many brands are still over-investing in high-gloss product photography, Philz is quietly winning the <strong>Aesthetic Arbitrage</strong> - leveraging Employee Generated Content (EGC) to turn routine drink builds into high-performing digital assets.
            </p>
            <p style={{ marginBottom: 0 }}>
              With only <strong>21.2k followers</strong>, Philz is punching way above its weight class. Here is the breakdown of why their "Raw" content is outperforming their "Polished" content and what it means for your brand's <strong>Human Moat</strong>.
            </p>
          </section>

          <section className="blog-post-section" id="data-audit">
            <h2>1. The Data Audit: Deconstructing the "Philz Formula"</h2>
            <p>
              A deep dive into 11 consecutive posts from the <strong>Philz Coffee</strong> feed in January of 2026, reveals a clear hierarchy of engagement. When we categorize these by "Production Style," we see a massive disparity between Corporate Assets and EGC.
            </p>
            <h3><a href={"#content-under-analysis"}>The "Main Character" Drink Build (68.7k Views)</a></h3>
            <p>
              The undisputed heavyweight champion of the month was a handheld, raw clip of an employee making a new menu item in-store.            
            </p>
            <ul>
              <li>
                The Takeaway: This outperformed the polished Canva product carousel (22.7k views) by 300%. Consumers don't want to see a digital rendering of a drink; they want to see the steam, the pour, and the barista's hands actually crafting it.
              </li>
            </ul>
            <h3><a href={"#content-under-analysis"}>The "Expert-Influencer" Effect (27.2k Views)</a></h3>
            <p>
              When Philz pivoted from "Product Promo" to "Barista’s Choice," the algorithm rewarded them. The "POV: Your Barista’s Order" video generated nearly double the views of their standard in-store graphic carousel (15.9k views).          
            </p>
            <ul>
              <li>
                The Insight: Your employees are already micro-influencers within their own four walls. Giving them the "Director’s Chair" to recommend their personal favorites builds a level of trust that a graphic designer simply cannot replicate.              
              </li>
            </ul>
            <h3><a href={"#content-under-analysis"}>Community Loop: The "Stitch & Respond" (14.7k Views)</a></h3>
            <p>
              Philz effectively used EGC to "close the loop" with their community by stitching videos and responding to comments with video builds.          
            </p>
            <ul>
              <li>
                The Strategy: This turns a static social media page into a Living Storefront. By having a real person respond to a digital comment with a physical action (making the drink), the brand signals that they are listening in real-time.
              </li>
            </ul>
            <h3><a href={"#content-under-analysis"}>The "Trend-Jacking" Trap (3.4k to 43k Views)</a></h3>
            <p>
              The data shows that trends are a gamble. A comedic "Green Screen" template hit high with 43.3k views, while a more niche "Nutty Cold Brew" trend stalled at 3.4k.          
            </p>
            <ul>
              <li>
                The Lesson: While EGC is the engine, context is the fuel. High-performing EGC isn't just about "filming stuff" - it’s about matching the internal "vibe" of the shop with the external "rhythm" of the internet.
              </li>
            </ul>
          </section>

          <section className="blog-post-section" id="barista-expert">
            <h2>2. The 3-Year Retention Proof</h2>
            <p>
              One of the most potent forms of EGC in the Philz data set is the <strong><a href={"#content-under-analysis"}>"POV: Your Barista's Order" (27.2k views)</a></strong>.
            </p>
            <p>
              In a world of infinite choices, consumers suffer from decision fatigue. When an employee steps out from behind the counter to say, "This is what I drink on my break," it carries more weight than a "Buy One Get One" coupon.
            </p>
            <ul>
              <li>
                <strong>Trust Transfer:</strong> The viewer stops seeing a "Corporate Entity" and starts seeing a "Trusted Guide."
              </li>
              <li>
                <strong>The Menu Hack:</strong> EGC allows employees to highlight "Secret Menu" items or custom builds, driving higher-margin modifications (extra shots, alternative milks) through organic discovery.
              </li>
            </ul>
          </section>

          <section className="blog-post-section" id="alive-store">
            <h2>3. The "Alive Store" Effect: Breaking the Fourth Wall</h2>
            <p>
              Philz uses <a href={"#content-under-analysis"}>EGC to "respond to comments" and "stitch" videos (14.7k views)</a>. This is a crucial component of the <strong>Human Moat</strong>.
            </p>
            <p>
              When a barista records a video answering a customer’s question about how the Pistachio Spice Cold Brew is made, they are doing more than "creating content." They are providing <strong>Customer Service at Scale</strong>.
            </p>
            <ul>
              <li>
                <strong>Bi-Directional Communication:</strong> Traditional ads talk at people. Philz baristas talk with people.
              </li>
              <li>
                <strong>Visual Proof:</strong> Seeing the actual steam, the actual pour, and the actual person proves the store is "Alive."
              </li>
            </ul>
          </section>

          <section className="blog-post-section" id="production-paradox">
            <h2>4. Why "Lo-Fi" is the New High-End</h2>
            <p>
              <a href={"#content-under-analysis"}>Notice the performance of the Graphic Carousel (15.9k views) versus the EGC Drink Build (68.7k views)</a>.
            </p>
            <p>
              The graphic is professionally designed, likely on a desktop, and approved through a chain of command. The drink build was likely shot on an iPhone in 45 seconds between orders.            
            </p>
            <ul>
              <li>
                <strong>The Production Paradox:</strong> The more money you spend on production, the more the viewer's "Ad-Blocker" brain kicks in.
              </li>
              <li>
                <strong>Frictionless Consumption:</strong> EGC feels like a FaceTime from a friend. It fits natively into the TikTok/Reels feed, leading to higher watch-through rates and better algorithmic favor.
              </li>
            </ul>
          </section>

          <section className="blog-post-section" id="operational-sop">
            <h2>5. Strategy: How to Build the Philz Pipeline</h2>
            <p>
              You don't need a creative agency to replicate these numbers. You need a <strong>System of Empowerment</strong>.
            </p>
            <p>
              The graphic is professionally designed, likely on a desktop, and approved through a chain of command. The drink build was likely shot on an iPhone in 45 seconds between orders.            
            </p>
            <ol>
              <li>
                <strong>Identify the "Brew-Masters":</strong> Find the baristas who already have a "main character" energy. These are your <strong>Content Captains</strong>.
              </li>
              <li>
                <strong>Define the "Signature" Frames:</strong> Give your team 3-5 "Low-Lift" prompts. (e.g., The First Pour, The Shift Drink, The Pre-Caffeine Struggle).
              </li>
              <li>
                <strong>Remove the Approval Bottleneck:</strong> If your baristas have to wait 3 days for a marketing manager to approve a "Let's make a latte" video, the trend is dead. Use a centralized platform to review and post in real-time.
              </li>
            </ol>
          </section>

          <section className="blog-post-section" id="final-verdict">
            <h2>6. The Verdict: Authenticity Scales, Polish Stagnates</h2>
            <p>
              The Philz Coffee data proves that <strong>Employee Generated Content</strong> is the most efficient way to grow a brand in 2026. You are sitting on a goldmine of content - it’s currently standing behind your espresso machines, wearing an apron.
            </p>
            <p>
              The "Human Moat" isn't built with a logo. It’s built by the hundreds of thousands of people who watched a barista pour a cup of coffee and thought, "I want to be there."
            </p>
            <p>
              <strong>Stop over-producing. Start empowering.</strong>
            </p>
          </section>

          <section className="blog-post-section" id="scaling-framework">
            <h2>7. Why "Lo-Fi" is the New High-End</h2>
            <p>
              The bottleneck to scaling EGC isn't talent - it's governance. How do you let 50 baristas film content without it becoming a "brand safety" nightmare?
            </p>
            <p>
              <strong>CrewCast</strong> provides the infrastructure to decentralize your content creation while keeping 100% centralized control.            
            </p>
            <ul>
              <li>
                <strong>Automated Prompt:</strong> Send "Barista's Choice" challenges directly to your team's phones.
              </li>
              <li>
                <strong>Instant Review:</strong> Approve, download, and post raw "gold" in seconds.
              </li>
              <li>
                <strong>Engagement Analytics:</strong> See which employees are driving the most brand affinity.
              </li>
            </ul>
            <h4>Book a CrewCast Demo: Turn Your Workforce into Your Most Powerful Content Engine</h4>
          </section>

          <section className="blog-post-section" id="content-under-analysis" style={{ scrollMarginTop: 120 }}>
            <h2>List of content under analysis</h2>
            <p className="blog-small" style={{ marginTop: 0 }}>
              Links below are the videos referenced throughout the article.
            </p>
            <ol>
              {tikTokLinks.map((v) => (
                <li key={v.id} style={{ marginBottom: 12 }}>
                  <a href={v.url} target="_blank" rel="noreferrer">
                    {v.label}
                  </a>
                  <div className="blog-small">Stats: {v.stats.join(' • ')}</div>
                </li>
              ))}
            </ol>
          </section>

          <section className="blog-post-section blog-post-cta">
            <h2>Want help implementing EGC?</h2>
            <p>Reach out and we’ll show you how CrewCast can turn everyday moments into an always-on content engine.</p>
            <button className="blog-btn primary" onClick={() => navigate('/contact')}>
              Book a Strategy Audit
            </button>
          </section>
        </article>
      </main>
    </div>
  );
}

